export default __webpack_public_path__ + "static/media/mektonz.0d2506c4.jpg";